import { useEffect, useState } from 'react'

import { useSelector } from 'react-redux'
import { STUDIO_COLLECTION } from 'util/postUtils'
import { isSignedIn } from 'redux/actions/accountActions'
import { isDesktop } from 'react-device-detect'

export default function NoContent() {
    const noContentStyles = {
        landscape: {
            width: '30vw',
            objectFit: 'contain'
        },
        portrait: {
            objectFit: 'cover',
            height: '100vh'
        }
    }
    const { currentCollection } = useSelector(state => state.harmonize)
    const [portrait, setIsPortrait] = useState(window.innerWidth > window.innerHeight ? false : true)
    const [imageSrc, setImageSrc] = useState()
    const [message, setMessage] = useState()

    const getContent = () => {
        const collection = currentCollection ? currentCollection : STUDIO_COLLECTION
        const { emptyImage, emptyMessage, emptyNotArtistMessage } = collection
        setImageSrc(emptyImage)
        setMessage(isSignedIn() ? emptyMessage : emptyNotArtistMessage)
    }
    useEffect(() => {
        getContent()
        const handleOrientationChange = () => {
            setIsPortrait(window.screen.orientation.type.startsWith('portrait'))
        }
        window.screen.orientation.addEventListener('change', handleOrientationChange)
        return () => {
            window.screen.orientation.removeEventListener('change', handleOrientationChange)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div style={{
            display: 'flex', flexDirection: 'column', width: '100vw', height: '100vh',
            backgroundColor: 'lightblue', justifyContent: 'center', alignItems: 'center',
            paddingLeft: '10vw', paddingRight: '10vw',
            position: 'relative'
        }}>
            <h3
                style={{
                    fontWeight: 'bold', marginLeft: '10vw', marginRight: '10vw',
                    textAlign: 'center', color: 'white', position: 'absolute', top: portrait ? '10vh' : '40vh'
                }}>
                {message}</h3>
            <img src={imageSrc} style={portrait ? noContentStyles.portrait : noContentStyles.landscape} />

        </div>
    )
}